import React, { useEffect, useState } from "react";
import "./GroupOpponentWaiting.css";
import playerImageFallback from "../../assets/images/c1.png";

function renderUserName(user, fallback) {
  return user?.name || user?.user_name || fallback;
}

function renderUserImage(user) {
  const image = user?.profile_pics || user?.image || "";
  if (!image) return playerImageFallback;
  return /^(https?:|data:|blob:)/i.test(image)
    ? image
    : `https://storage.googleapis.com/vidyakasam-user/${String(image).replace(/^\/+/, "")}`;
}

const GroupBattleCard = ({
  initialTime = 20,
  currentPlayerName = "Student",
  currentPlayerImage = "",
  currentUserId = 0,
  users = [],
  roomCode = "",
  entryMode = "random",
  waitingCount = 3,
  isChallengeReady = false,
  canStart = false,
  onStart,
  onCopyCode,
  onShareCode,
  onLeave,
}) => {
  const [timeLeft, setTimeLeft] = useState(Math.max(0, Number(initialTime || 0)));

  useEffect(() => {
    setTimeLeft(Math.max(0, Number(initialTime || 0)));
  }, [initialTime]);

  useEffect(() => {
    if (timeLeft <= 0) {
      return undefined;
    }

    const timer = window.setInterval(() => {
      setTimeLeft((current) => Math.max(0, current - 1));
    }, 1000);

    return () => window.clearInterval(timer);
  }, [timeLeft]);

  const progressBase = Math.max(1, Number(initialTime || 1));
  const progress = timeLeft / progressBase;
  const playerImage = currentPlayerImage || playerImageFallback;
  const opponents = currentUserId
    ? users.filter((user) => Number(user?.user_id || user?.id || 0) !== Number(currentUserId))
    : users.slice(1);
  const visibleOpponents = Array.from({ length: waitingCount }, (_, index) => opponents[index] || null);
  const waitingSubText = isChallengeReady
    ? entryMode === "friend"
      ? canStart
        ? "Enough players joined. Start the battle when you are ready."
        : "Enough players joined. Waiting for room creator to start."
      : "All players joined. Battle will start automatically."
    : entryMode === "friend"
      ? "Share the room code and wait for other players to join."
      : "Room will start automatically once all players join.";

  return (
    <div className="waitingRoomWrapper">
      <div className="waitingRoom">
        {isChallengeReady || entryMode === "friend" ? (
          <div className="challengeReadyIcon">
            <i className="bi bi-lightning-charge-fill"></i>
          </div>
        ) : (
          <div className="countdownTimer">
            <svg className="countdownSvg" viewBox="0 0 100 100">
              <circle className="countdownTrack" cx="50" cy="50" r="44" />
              <circle
                className="countdownProgress"
                cx="50"
                cy="50"
                r="44"
                style={{ strokeDashoffset: 276.46 * (1 - progress) }}
              />
            </svg>

            <span className="countdownTime">{timeLeft}</span>
          </div>
        )}

        <div className="waitingHeading">
          {entryMode === "friend"
            ? isChallengeReady ? canStart ? "Ready to Start" : "Waiting for Room Creator" : "Waiting for Friends"
            : isChallengeReady ? "Challenge Begins" : "Waiting for other opponents"}
        </div>
        <div className="waitingSubText">{waitingSubText}</div>

        {entryMode === "friend" && roomCode ? (
          <div className="gamification-room-code">
            <span>Room Code</span>
            <strong>#{roomCode}</strong>
            <button type="button" onClick={onCopyCode}>Copy</button>
            <button type="button" onClick={onShareCode}>Share</button>
          </div>
        ) : null}

        <div className="currentPlayerSection">
          <div className="playerImageWrapper">
            <img src={playerImage} alt="Player" className="playerImage" />
            <span className="youBadge">YOU</span>
          </div>

          <div className="playerName">{currentPlayerName}</div>
        </div>

        <div className="versusSection">
          <div className="versusLine"></div>
          <span className="versusText">Versus</span>
          <div className="versusLine"></div>
        </div>

        <div className="opponentsWrapper">
          {visibleOpponents.map((user, index) => (
            <div className="opponentItem" key={user?.user_id || `waiting-${index}`}>
              <div className="waitingImageCircle">
                <img
                  src={user ? renderUserImage(user) : playerImageFallback}
                  alt={user ? renderUserName(user, "Opponent") : "Waiting opponent"}
                  className="waitingOpponentImage"
                />
              </div>

              <div className="opponentWaitingText">
                {user ? renderUserName(user, `Opponent ${index + 1}`) : "Waiting..."}
              </div>
            </div>
          ))}
        </div>

        {canStart ? (
          <button type="button" className="gamification-start-button" onClick={onStart}>
            Start Battle
          </button>
        ) : null}

        <button type="button" className="gamification-leave-button" onClick={onLeave}>
          {entryMode === "friend" ? "Leave Room" : "Leave Queue"}
        </button>
      </div>
    </div>
  );
};

export default GroupBattleCard;
